
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.088 5.978H5.513c-1.885 0-3.413 1.88-3.413 4.2 0 2.32 1.528 4.2 3.413 4.2h1.575c.435 0 .787-.435.787-.97v-6.46c0-.536-.352-.97-.787-.97zM6.3 7.916v4.522l-.787.001c-1.015 0-1.838-1.012-1.838-2.261l.006-.186c.077-1.162.868-2.076 1.832-2.076H6.3z"}}),_c('path',{attrs:{"d":"M16.1 2.264l-.793.652c-2.434 1.996-5.294 3.062-8.22 3.062-.434 0-.787.434-.787.97v6.46c0 .535.353.97.787.97 2.926 0 5.786 1.065 8.22 3.062l.794.651c.523.43 1.224-.032 1.224-.806V3.07c0-.774-.7-1.236-1.224-.807zm-.35 2.603v10.62l-.315-.237c-2.27-1.653-4.833-2.607-7.467-2.782l-.093-.005V7.89l.093-.004c2.634-.174 5.196-1.129 7.467-2.782l.315-.238zM18.638 7.916c.398 0 .728.365.78.838l.007.132v2.584c0 .535-.352.969-.787.969-.4 0-.729-.365-.78-.838l-.008-.131V8.886c0-.536.353-.97.788-.97z"}}),_c('path',{attrs:{"d":"M7.088 12.44c.435 0 .787.434.787.969 0 1.444.48 2.825 1.33 3.82.315.369.328.982.028 1.37-.3.388-.798.403-1.113.034-1.163-1.361-1.821-3.25-1.82-5.225 0-.536.353-.97.788-.969z"}})])
          )
        }
      }
    